// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-post-post-status .components-base-control {
    flex: auto;
}

.editor-post-title__panel,
.editor-post-description__panel {
    padding-top: 8px;
}

.editor-post-status__panel {
    margin-top: 16px;
    gap: 16px !important;
}

.editor-post-status__panel button {
    flex-grow: 1;
    justify-content: center;
}

.workflow-editor-element-inspector__warning {
    background: #fff;
    display: block;
    font-size: 13px;
    padding: 32px 36px;
    text-align: center;
    flex-grow: 1;
    justify-content: center;
}


.workflow-editor-inspector-card {
    align-items: flex-start;
    color: #1e1e1e;
    display: flex;
    padding: 16px;
}

.workflow-editor-inspector-card {
    align-items: flex-start;
    color: #1e1e1e;
    display: flex;
    padding: 16px;
}

.workflow-editor-inspector-icon {
    align-items: center;
    display: flex;
    height: 24px;
    justify-content: center;
    width: 24px;
}

.workflow-editor-inspector-card .workflow-editor-inspector-icon {
    flex: 0 0 24px;
    height: 24px;
    margin-left: 0;
    margin-right: 12px;
    width: 24px;
}

.workflow-editor-inspector-card {
    align-items: flex-start;
    color: #1e1e1e;
    display: flex;
    padding: 16px;
}

.workflow-editor-inspector-card__content {
    flex-grow: 1;
}

.workflow-editor-inspector-inspector h2, .workflow-editor-inspector-inspector h3 {
    color: #1e1e1e;
    font-size: 13px;
    margin-bottom: 1.5em;
}

.interface-complementary-area h2 {
    color: #1e1e1e;
    font-size: 13px;
    margin-bottom: 1.5em;
}

.workflow-editor-inspector-card__title.workflow-editor-inspector-card__title {
    font-size: 13px;
    line-height: 1.4;
    margin: 0;
    padding: 3px 0;
}


.workflow-editor-inspector-card__description {
    display: block;
    font-size: 13px;
    line-height: 1.4;
    margin-top: 4px;
}

.workflow-editor-inspector-icon.has-colors svg {
    fill: currentColor;
}

.workflow-editor-inspector-icon svg {
    max-height: 24px;
    max-width: 24px;
    min-height: 20px;
    min-width: 20px;
}

.workflow-editor-validation-notification {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}

.workflow-editor-validation-panel .node-icon {
    margin-right: 5px;
}

.workflow-editor-validation-notification.workflow-editor-success .node-icon * {
    color: #46b450;
}

.workflow-editor-validation-notification.workflow-editor-error .node-icon * {
    color: #d90f0f;
}

.edit-post-sidebar__panel .components-h-stack {
    width: 100%;
}

.workflow-editor-inspector-card__content table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-top: 20px;
}

.workflow-editor-inspector-card__content table th,
.workflow-editor-inspector-card__content table td {
    padding: 2px 3px;
    border: 1px solid #e1e1e1;
    text-align: left;
}

.workflow-editor-data-flow-variable ul {
    margin-left: 40px;
    margin-top: 6px;
    margin-bottom: 11px;
    padding: 2px;
}

.workflow-editor-data-flow-variable ul li {
    margin-bottom: 2px;
    list-style: disc;
    line-height: 16px;
}

.workflow-editor-data-flow-variable ul code {
    max-width: 204px;
    display: inline-block;
    overflow: auto;
    text-wrap: wrap;
}

p.settings-field-description,
p.description {
    margin-top: -14px !important;
    font-size: 12px;
    font-style: normal;
    color: rgb(117, 117, 117);
}

p.description.margin-top {
    margin-top: 8px !important;
}

.components-panel__row .components-base-control {
    width: 100%;
}

.components-form-token-field__help {
    display: none;
}

.margin-bottom-0 {
    margin-bottom: 0 !important;
}

.margin-bottom-0 .components-base-control {
    margin-bottom: 0 !important;
}

.margin-top-0 {
    margin-top: 0 !important;
}

.workflow-editor-setting-popover .components-popover__content {
    min-width: 320px;
    padding: 16px;
}


.workflow-editor-inspector-card__header {
    justify-content: flex-start !important;
}

.workflow-editor-inspector-card__content .components-v-stack {
    margin-bottom: 10px;
}

.workflow-editor-post-data.hidden-calendar .components-datetime__date {
    display: none;
}

.workflow-editor-panel {
    gap: calc(4px) !important;
}

.workflow-editor-panel__row {
    width: 100%;
}

.workflow-editor-panel__row-label {
    min-width: 0px;
    align-items: center;
    display: flex;
    flex-shrink: 0;
    hyphens: auto;
    line-height: 20px;
    min-height: 32px;
    padding: 6px 0;
    width: 38%;
}

.workflow-editor-panel__row-control {
    min-width: 0px;
    align-items: center;
    display: flex;
    flex-grow: 1;
    min-height: 32px;
    max-height: 38px;
    overflow: hidden;
    word-break: break-word;
    flex-wrap: wrap;
    hyphens: auto;
    line-height: 20px;
}

.workflow-editor-panel__row-control .components-button.is-tertiary {
    white-space: normal;
    height: 38px;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    align-items: center;
    padding: 4px 8px;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/inspector.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;AAC3B;;;AAGA;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;;AAGA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;;AAGA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".edit-post-post-status .components-base-control {\n    flex: auto;\n}\n\n.editor-post-title__panel,\n.editor-post-description__panel {\n    padding-top: 8px;\n}\n\n.editor-post-status__panel {\n    margin-top: 16px;\n    gap: 16px !important;\n}\n\n.editor-post-status__panel button {\n    flex-grow: 1;\n    justify-content: center;\n}\n\n.workflow-editor-element-inspector__warning {\n    background: #fff;\n    display: block;\n    font-size: 13px;\n    padding: 32px 36px;\n    text-align: center;\n    flex-grow: 1;\n    justify-content: center;\n}\n\n\n.workflow-editor-inspector-card {\n    align-items: flex-start;\n    color: #1e1e1e;\n    display: flex;\n    padding: 16px;\n}\n\n.workflow-editor-inspector-card {\n    align-items: flex-start;\n    color: #1e1e1e;\n    display: flex;\n    padding: 16px;\n}\n\n.workflow-editor-inspector-icon {\n    align-items: center;\n    display: flex;\n    height: 24px;\n    justify-content: center;\n    width: 24px;\n}\n\n.workflow-editor-inspector-card .workflow-editor-inspector-icon {\n    flex: 0 0 24px;\n    height: 24px;\n    margin-left: 0;\n    margin-right: 12px;\n    width: 24px;\n}\n\n.workflow-editor-inspector-card {\n    align-items: flex-start;\n    color: #1e1e1e;\n    display: flex;\n    padding: 16px;\n}\n\n.workflow-editor-inspector-card__content {\n    flex-grow: 1;\n}\n\n.workflow-editor-inspector-inspector h2, .workflow-editor-inspector-inspector h3 {\n    color: #1e1e1e;\n    font-size: 13px;\n    margin-bottom: 1.5em;\n}\n\n.interface-complementary-area h2 {\n    color: #1e1e1e;\n    font-size: 13px;\n    margin-bottom: 1.5em;\n}\n\n.workflow-editor-inspector-card__title.workflow-editor-inspector-card__title {\n    font-size: 13px;\n    line-height: 1.4;\n    margin: 0;\n    padding: 3px 0;\n}\n\n\n.workflow-editor-inspector-card__description {\n    display: block;\n    font-size: 13px;\n    line-height: 1.4;\n    margin-top: 4px;\n}\n\n.workflow-editor-inspector-icon.has-colors svg {\n    fill: currentColor;\n}\n\n.workflow-editor-inspector-icon svg {\n    max-height: 24px;\n    max-width: 24px;\n    min-height: 20px;\n    min-width: 20px;\n}\n\n.workflow-editor-validation-notification {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.workflow-editor-validation-panel .node-icon {\n    margin-right: 5px;\n}\n\n.workflow-editor-validation-notification.workflow-editor-success .node-icon * {\n    color: #46b450;\n}\n\n.workflow-editor-validation-notification.workflow-editor-error .node-icon * {\n    color: #d90f0f;\n}\n\n.edit-post-sidebar__panel .components-h-stack {\n    width: 100%;\n}\n\n.workflow-editor-inspector-card__content table {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n    margin-top: 20px;\n}\n\n.workflow-editor-inspector-card__content table th,\n.workflow-editor-inspector-card__content table td {\n    padding: 2px 3px;\n    border: 1px solid #e1e1e1;\n    text-align: left;\n}\n\n.workflow-editor-data-flow-variable ul {\n    margin-left: 40px;\n    margin-top: 6px;\n    margin-bottom: 11px;\n    padding: 2px;\n}\n\n.workflow-editor-data-flow-variable ul li {\n    margin-bottom: 2px;\n    list-style: disc;\n    line-height: 16px;\n}\n\n.workflow-editor-data-flow-variable ul code {\n    max-width: 204px;\n    display: inline-block;\n    overflow: auto;\n    text-wrap: wrap;\n}\n\np.settings-field-description,\np.description {\n    margin-top: -14px !important;\n    font-size: 12px;\n    font-style: normal;\n    color: rgb(117, 117, 117);\n}\n\np.description.margin-top {\n    margin-top: 8px !important;\n}\n\n.components-panel__row .components-base-control {\n    width: 100%;\n}\n\n.components-form-token-field__help {\n    display: none;\n}\n\n.margin-bottom-0 {\n    margin-bottom: 0 !important;\n}\n\n.margin-bottom-0 .components-base-control {\n    margin-bottom: 0 !important;\n}\n\n.margin-top-0 {\n    margin-top: 0 !important;\n}\n\n.workflow-editor-setting-popover .components-popover__content {\n    min-width: 320px;\n    padding: 16px;\n}\n\n\n.workflow-editor-inspector-card__header {\n    justify-content: flex-start !important;\n}\n\n.workflow-editor-inspector-card__content .components-v-stack {\n    margin-bottom: 10px;\n}\n\n.workflow-editor-post-data.hidden-calendar .components-datetime__date {\n    display: none;\n}\n\n.workflow-editor-panel {\n    gap: calc(4px) !important;\n}\n\n.workflow-editor-panel__row {\n    width: 100%;\n}\n\n.workflow-editor-panel__row-label {\n    min-width: 0px;\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    hyphens: auto;\n    line-height: 20px;\n    min-height: 32px;\n    padding: 6px 0;\n    width: 38%;\n}\n\n.workflow-editor-panel__row-control {\n    min-width: 0px;\n    align-items: center;\n    display: flex;\n    flex-grow: 1;\n    min-height: 32px;\n    max-height: 38px;\n    overflow: hidden;\n    word-break: break-word;\n    flex-wrap: wrap;\n    hyphens: auto;\n    line-height: 20px;\n}\n\n.workflow-editor-panel__row-control .components-button.is-tertiary {\n    white-space: normal;\n    height: 38px;\n    text-align: left;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    align-items: center;\n    padding: 4px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
